export default __webpack_public_path__ + "static/media/pickup-delivery-image.b2fb7b30.jpg";